import styled from "styled-components";
export const AlignRightWithMaxWidth = styled.div `
  && > * {
    max-width: 18rem;
    margin-left: auto;
  }
`;
